import { format, parseISO } from 'date-fns';
import { ko } from 'date-fns/locale';

export function fmtKst(iso: string | null | undefined, pattern = 'yyyy.MM.dd HH:mm'): string {
  if (!iso) return '-';
  try {
    // ko 로케일 — (E) 요일 패턴이 '금'처럼 한국어로 나온다
    return format(parseISO(iso), pattern, { locale: ko });
  } catch {
    return iso;
  }
}
